import { WIcon } from '@alice-health/wonderland-react'
import classNames from 'classnames'
import { motion, AnimatePresence } from 'framer-motion'
import { FunctionComponent } from 'react'

interface MapContainerLoaderProps {
  isLoading: boolean
}

const MapContainerLoader: FunctionComponent<MapContainerLoaderProps> = ({
  isLoading
}) => {
  return (
    <AnimatePresence>
      {isLoading ? (
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          transition={{ duration: 0.2 }}
          className={classNames(
            'absolute',
            'h-[43px] w-[190px] py-gl-spacing-03 px-gl-spacing-05',
            'flex items-center justify-center',
            'bg-sys-color-surface-container-active rounded-gl-border-radius-lg shadow-sm',
            'left-[calc(50%-95px)] bottom-[50%] translate-y-[50%] -translate-x-[50%]',
            'desktop-short:left-[calc(50%+(170px))] desktop-short:bottom-[100px]',
            'lg:bottom-[118px] lg:translate-y-0'
          )}
        >
          <WIcon
            className='animate-spin'
            icon='icLoad'
            size='large'
          />
        </motion.div>
      ) : null}
    </AnimatePresence>
  )
}

export { MapContainerLoader }
